import React from "react";
import { Box, Divider } from "@mui/material";
import InnerFrame from "../shared/InnerFrame";
import SkillRow from "./SkillRow";

export default function SkillCard({
  parentSkill,
  childSkills,
  onParentLevelChange,
  onChildLevelChange,
  isDesktop,
}) {
  if (!parentSkill) return null;

  return (
    <InnerFrame
      sx={{
        p: isDesktop ? 5 : 2.5,
        width: "100%",
        maxWidth: "900px",
        mx: 0,
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: isDesktop ? 3 : 0,
        }}
      >
        <SkillRow
          displayName={parentSkill.displayName}
          experienceLabel={parentSkill.experienceLabel}
          levelValue={parentSkill.levelValue}
          onChangeLevel={onParentLevelChange}
          isDesktop={isDesktop}
        />

        {childSkills.length > 0 && <Divider sx={{ my: 1 }} />}

        {childSkills.map((child) => (
          <Box
            key={child.recordId}
            sx={{
              pl: isDesktop ? 0 : 3,
              pt: isDesktop ? 0 : 2.5,
            }}
          >
            <SkillRow
              displayName={child.displayName}
              experienceLabel={child.experienceLabel}
              levelValue={child.levelValue}
              isChild
              isDesktop={isDesktop}
              onChangeLevel={(value) =>
                onChildLevelChange(child.recordId, value)
              }
            />
          </Box>
        ))}
      </Box>
    </InnerFrame>
  );
}
